export default __webpack_public_path__ + "static/media/eye-off.931ba0a8.svg";